import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=68ce7b86&"
import script from "./ChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ce7b86')) {
      api.createRecord('68ce7b86', component.options)
    } else {
      api.reload('68ce7b86', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=68ce7b86&", function () {
      api.rerender('68ce7b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/ChangePassword.vue"
export default component.exports